import React, { useContext, useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import MenuIcon from '@mui/icons-material/Menu'
import {
  Badge,
  Button,
  Chip,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import { SiteModeContext } from '../../../components/mainFrame/MainFrame'
import moment from 'moment'
import { EPCRContext } from './EPCR'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle'
import CloudDoneIcon from '@mui/icons-material/CloudDone'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import { getFormType, isFullLayoutMode } from './formTypes'
import FavoriteIcon from '@mui/icons-material/Favorite'
import BoltIcon from '@mui/icons-material/Bolt'

export const syncStatusColors = (variable) => {
  switch (variable) {
    case 'error':
      return '#E32525'
    case 'done':
      return '#2e7d32'
    default:
      return '#ed6c02'
  }
}

const EPCRHeader = ({ ptDetails, epcrMode, epcrNumber }) => {
  const { setSidebarState, epcrPracticeMode } = useContext(SiteModeContext)
  const {
    uploadState,
    downloadState,
    setFormTypeDialogOpen,
    selectedEPCRModule,
    setSelectedEPCRModule,
  } = useContext(EPCRContext)
  const fullLayout = isFullLayoutMode(epcrMode)
  const formType = getFormType(epcrMode)
  const [currentTime, setCurentTime] = useState(moment())

  useEffect(() => {
    const timer = setInterval(() => setCurentTime(moment()), 1000)
    return () => clearInterval(timer)
  }, [])

  const uploadIconSx = {
    width: '1.5rem',
    height: '1.5rem',
    color: () => syncStatusColors(uploadState),
  }

  const downloadIconSx = {
    width: '1.5rem',
    height: '1.5rem',
    color: () => syncStatusColors(downloadState),
  }

  return (
    <Box
      display="flex"
      gap={1}
      component={Paper}
      padding={1}
      justifyContent="space-between"
      color={epcrPracticeMode ? 'white' : formType.color}
      bgcolor={epcrPracticeMode ? '#990000' : (formType.bg ?? undefined)}
    >
      {!fullLayout ? (
        <Tooltip title="Change Record Type" sx={{ cursor: 'pointer' }}>
          <ChangeCircleIcon onClick={() => setFormTypeDialogOpen(true)} />
        </Tooltip>
      ) : (
        <MenuIcon
          onClick={() =>
            setSidebarState((prev) => ({ ...prev, mobileOpen: true }))
          }
          display={{ xs: 'block', lg: 'none' }}
        />
      )}
      <Typography>
        {epcrPracticeMode
          ? 'PRACTICE MODE'
          : (formType.headerTitle ?? ptDetails)}
      </Typography>
      <Box display="flex" gap={{ xs: 1, md: 2 }} alignItems="center">
        {epcrMode === 'Critical Care' && selectedEPCRModule !== 'Live' && (
          <Button
            size="small"
            variant="contained"
            color="inherit"
            startIcon={<BoltIcon />}
            onClick={() => setSelectedEPCRModule('Live')}
            sx={{ py: 0, whiteSpace: 'nowrap', color: formType.color }}
          >
            Live
          </Button>
        )}
        {fullLayout && selectedEPCRModule !== 'Arrest' && (
          <Button
            size="small"
            variant="contained"
            color="error"
            startIcon={<FavoriteIcon />}
            onClick={() => setSelectedEPCRModule('Arrest')}
            sx={{ py: 0, whiteSpace: 'nowrap' }}
          >
            <Box component="span" display={{ xs: 'none', sm: 'inline' }}>
              Cardiac&nbsp;
            </Box>
            arrest
          </Button>
        )}
        <Typography
          sx={{
            display: {
              xs: 'none',
              lg: 'inherit',
            },
          }}
        >
          {moment(currentTime).format('LTS')}
        </Typography>
        {!epcrPracticeMode && (
          <Box display="flex" gap={0.5} alignItems="center">
            {uploadState === 'done' ? (
              <CloudDoneIcon sx={uploadIconSx} />
            ) : uploadState === 'pending' ? (
              <CloudUploadIcon sx={uploadIconSx} />
            ) : (
              <CloudOffIcon sx={uploadIconSx} />
            )}
            {downloadState === 'done' ? (
              <CloudDoneIcon sx={downloadIconSx} />
            ) : downloadState === 'pending' ? (
              <CloudDownloadIcon sx={downloadIconSx} />
            ) : (
              <CloudOffIcon sx={downloadIconSx} />
            )}
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default EPCRHeader
